import(/* webpackMode: "eager" */ "/workspace/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["UpdateTreeDialog"] */ "/workspace/src/components/update-tree-dialog.tsx");
